export default __webpack_public_path__ + "static/media/banner-home.f091db04.png";